module.exports = __webpack_public_path__ + "img/07-dora&phil.800885c0.jpg";